import React from "react"
import { Line } from "react-konva"

export const drawGrid = () => {
    const gridSize = 20
    const grid = []
    const stageWidth = window.innerWidth
    const stageHeight = window.innerHeight

    for (let i = 0; i < stageWidth / gridSize; i++) {
        grid.push(
            <Line
                key={`v${i}`}
                points={[i * gridSize, 0, i * gridSize, stageHeight]}
                stroke="#ddd"
                strokeWidth={1}
            />
        )
    }

    for (let i = 0; i < stageHeight / gridSize; i++) {
        grid.push(
            <Line
                key={`h${i}`}
                points={[0, i * gridSize, stageWidth, i * gridSize]}
                stroke="#ddd"
                strokeWidth={1}
            />
        )
    }

    return grid
}